import axios from 'axios';
import store from '../store/index';

//const url = 'http://localhost:8080';
//const url = 'https://staffassessor.ew.r.appspot.com/'
//const url = "https://staffassessor.vercel.app"
//const url = "https://staffassessor.onrender.com";
//const url = "https://assessor.up.railway.app"
//const url = 'https://www.easymuster.com.ng';
const url = process.env.VUE_APP_API_URL;

export default class DataService {
    static async register(emailObj) {
        const res = await axios.post(`${url}/register`, emailObj).catch(e => {
            alert('An error occurred')
            console.log(e.response.data)
        })
        if (res) {
            return res.data
        }
    }

    static async login(emailObj) {
        const res = await axios.post(`${url}/login/`, emailObj).catch(e => {
            alert('An error occurred')
            console.log(e.response.data)
        })
        if (res) {
            return res.data
        }
    }

    static async saveData(dataDetails) {
        var candidateId = store.state.user._id

        const res = await axios.post(`${url}/savedata/${candidateId}`, dataDetails).catch(e => {
            alert('An error occurred')
            console.log(e.response.data);
        });

        if (res) {
           return(res.data)
        };
    }

    static async deleteExternal(candidateId, assessorId) {
        var id = {
            assessorId: assessorId
        }

        const res = await axios.delete(`${url}/deleteexternal/${candidateId}`, { data: id}).catch(e => {
            alert('An error occurred')
            console.log(e.response.data);
        });

        if (res) {
           return(res.data)
        };
    }

    static async assignExternal(assessor) {
        var candidateId = assessor.candidateId

        const res = await axios.post(`${url}/assignexternal/${candidateId}`, assessor).catch(e => {
            alert('An error occurred')
            console.log(e.response.data);
        });

        if (res) {
           return(res.data)
        };
    }

    static async submitComments(commentDetails) {
        const config = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + commentDetails.token
            }
        }

        const res = await axios.post(`${url}/submitcomments`, commentDetails, config).catch(e => {
            alert('An error occurred')
            console.log(e.response.data);
        });

        if (res) {
           return(res.data)
        };
    }

    static async submitAssessment(details) {
        const config = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + details.token
            }
        }

        const res = await axios.post(`${url}/submitassessment/${details.candidateId}`, details, config).catch(e => {
            alert('An error occurred')
            console.log(e.response.data);
        });

        if (res) {
           return(res.data)
        };
    }

    static async deleteFile(fileDetails) {
        var candidateId = store.state.user._id

        const res = await axios.delete(`${url}/deletefile/${candidateId}`, { data: { source: fileDetails } }).catch(e => {
            alert('An error occurred')
            console.log(e.response.data)
        })

        if (res) {
            return res.data;
        }
    }

    static async getCandidates() {
        var candidates = await axios.get(`${url}/getcandidates/`).catch(e => {
            alert('An error occurred')
            console.log(e.response.data)
        })

        if (candidates) {
            return candidates.data
        }
    }

    static async getCandidate(id) {
        var candidate = await axios.get(`${url}/getcandidate/${id}`).catch(e => {
            alert('An error occurred')
            console.log(e.response.data)
        })
        if (candidate) {
            return candidate.data
        }
    }

    static async scoreItem(scoreDetails) {
        const config = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + scoreDetails.token
            }
        }

        const candidate = await axios.put(`${url}/scoreitem`, scoreDetails, config).catch(e => {
            alert('An error occurred')
            console.log(e.response.data)
        });
        if (candidate) {
            return candidate.data
        }
    }

    static async generateToken(certifier) {
        const token = await axios.get(`${url}/generatetoken?certifier=${certifier}`).catch(e => {
            alert('An error occured')
            console.log(e.response.data)
        });
        if (token) {
            return token.data
        }
    }

    static isLoggedIn() {
        return store.state.user ? true : false;
    }
}